<template>
  <div class="home-page">
    <router-view></router-view>
    <my-footer></my-footer>
  </div>

</template>

<script>
  import Footer from '../components/footer/Footer'

  export default {
    name: 'home',
    components: {
      'my-footer': Footer,
    },
  }
</script>
<style>
  .home-page {
    background-color: white;
    padding-bottom: 1.5rem;
  }
</style>
